module.exports = __webpack_public_path__ + "img/Tuvalu.f3648c84.svg";